const isObject = (value) => value !== null && typeof value === "object" && !Array.isArray(value);

// Draft JSON is serialized with PascalCase, while the form uses the API's camelCase fields.
const normalizeKeys = (value) => {
  if (Array.isArray(value)) return value.map(normalizeKeys);
  if (!isObject(value)) return value;
  return Object.fromEntries(
    Object.entries(value).map(([key, item]) => [key.charAt(0).toLowerCase() + key.slice(1), normalizeKeys(item)]),
  );
};

export const parseDraftOrder = (draft) => {
  const data = normalizeKeys(JSON.parse(draft.jsonData));
  if (!isObject(data)) throw new Error("Invalid draft data");
  const nested = Object.prototype.hasOwnProperty.call(data, "order");
  const order = nested ? data.order : data;
  if (!isObject(order)) throw new Error("Invalid draft order");
  const expeditors = data.expeditors ?? order.expeditors ?? [];
  if (!Array.isArray(expeditors) || (order.addressList != null && !Array.isArray(order.addressList))) {
    throw new Error("Invalid draft collections");
  }
  return {
    order: {
      ...order,
      number: order.number ?? draft.number,
      internalNumber: order.internalNumber ?? draft.internalNumber,
      userId: order.userId ?? draft.userId,
      assignmentMethod: order.assignmentMethod ?? (order.expeditorId ? "DirectAssignment" : "Tender"),
      insuranceIncluded: order.insuranceIncluded ?? order.isInsurance ?? false,
      tenderDateEnd: data.tenderDateEnd ?? order.tenderDateEnd,
      isComplexTender: data.isComplexTender ?? order.isComplexTender ?? false,
      vehiclesCount: data.vehiclesCount ?? order.vehiclesCount ?? 1,
    },
    tenderPartners: expeditors,
  };
};
